import { Entry } from '../Entry'

export function Entry20220824() {
  return (
    <Entry title="24/08/2022 - v3.2.1">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12710/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
